module.exports = __webpack_public_path__ + "img/people@2x.576cfe95.png";